import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const DestinoSlide = ({ item }) => {
  const [imgCargada, setImgCargada] = useState(false);
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/destino/${item.id}`, { state: { from: "home" } })}
      className="destino-card destino-card--fly"
    >
      <div className="destino-img-container destino-img-container--fly">
        {!imgCargada && <div className="skeleton-destino" />}
        <img
          loading="lazy"
          src={item.foto || "/assets/images/default-destino.jpg"}
          alt={item.nombre}
          className="destino-img destino-img--fly"
          style={{ opacity: imgCargada ? 1 : 0 }}
          onLoad={() => setImgCargada(true)}
          onError={() => setImgCargada(true)}
        />
        <div className="destino-chip destino-chip--left">
          <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
          </svg>
          <span>{item.recomendaciones ? `${item.recomendaciones}` : "Fly"}</span>
        </div>
        <div className="destino-chip destino-chip--right">
          <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7m0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5" />
          </svg>
        </div>
      </div>

      <div className="destino-info destino-info--fly">
        <div className="destino-title destino-title--fly">
          <h4>{item.nombre}</h4>
          <span className="destino-subtitle">{item.municipio}</span>
        </div>
        <div className="destino-location destino-location--fly">
          <svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true">
            <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
              <path d="M12.56 20.82a.96.96 0 0 1-1.12 0C6.611 17.378 1.486 10.298 6.667 5.182A7.6 7.6 0 0 1 12 3c2 0 3.919.785 5.333 2.181c5.181 5.116.056 12.196-4.773 15.64"/>
              <path d="M12 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>
            </g>
          </svg>
          <span>{item.municipio}.</span>
        </div>
      </div>
    </div>
  );
};

export default DestinoSlide;
